/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SendSalesEmailResponse
 */
export interface SendSalesEmailResponse {
  /**
   *
   * @type {boolean}
   * @memberof SendSalesEmailResponse
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof SendSalesEmailResponse
   */
  errorMessage?: string | null;
}

/**
 * Check if a given object implements the SendSalesEmailResponse interface.
 */
export function instanceOfSendSalesEmailResponse(
  value: object,
): value is SendSalesEmailResponse {
  if (!("success" in value) || value["success"] === undefined) return false;
  return true;
}

export function SendSalesEmailResponseFromJSON(
  json: any,
): SendSalesEmailResponse {
  return SendSalesEmailResponseFromJSONTyped(json, false);
}

export function SendSalesEmailResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SendSalesEmailResponse {
  if (json == null) {
    return json;
  }
  return {
    success: json["success"],
    errorMessage:
      json["errorMessage"] == null ? undefined : json["errorMessage"],
  };
}

export function SendSalesEmailResponseToJSON(
  json: any,
): SendSalesEmailResponse {
  return SendSalesEmailResponseToJSONTyped(json, false);
}

export function SendSalesEmailResponseToJSONTyped(
  value?: SendSalesEmailResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    success: value["success"],
    errorMessage: value["errorMessage"],
  };
}
